// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalConfigPage_container__8cRjA"};